import allPromisesWithRetries from '@/helpers/allPromisesWithRetries'

export const fetchModules = () => (
  allPromisesWithRetries(() => [
    import('@/services/FramedCheckout/shipmentServices/updateShippingAddress'),
    import('@/services/FramedCheckout/shipmentServices/updateShippingOption'),
    import('@/helpers/stateNameAcronymMapping'),
    import('@/services/FramedCheckout/orderServices/getOrder'),
    import('@/services/Cart/getCart'),
    import('@/services/FramedCheckout/paymentServices/updateBillingAddress'),
    import('@/services/FramedCheckout/customerServices'),
    import('@/services/FramedCheckout/orderServices/postOrderFlow'),
    import('@/services/ApplePay/confirmPaymentIntent'),
    import('@/services/FramedCheckout/paymentServices/completePayment'),
    import('@/services/FramedCheckout/cscPaymentsServices/getSavedInstrumentsCredentials'),
    import('@csc/csc-sdk'),
    import('@/services/FramedCheckout/navigationServices'),
  ])
    .then(([
      { updateShippingAddress },
      { updateShippingOption },
      { mapStateToFullName, mapStateToAcronym },
      { getOrder },
      { getCart },
      { updateBillingAddress },
      { getCustomer },
      { postOrderFlow },
      { confirmPaymentIntent },
      { completePayment },
      { getSavedInstrumentsCredentials },
      { default: CSC },
      { goToConfirmation },
    ]) => ({
      updateShippingAddress,
      updateShippingOption,
      mapStateToFullName,
      mapStateToAcronym,
      getOrder,
      getCart,
      updateBillingAddress,
      customerPromise: getCustomer(),
      postOrderFlow,
      confirmPaymentIntent,
      completePayment,
      credentialsPromise: getSavedInstrumentsCredentials(),
      goToConfirmation,
      CSC,
      ...CSC,
    }))
)

export type StripeModules = ReturnType<typeof fetchModules>
